import React from 'react';

type LoadingBarProps = {
  active: boolean;
};

function LoadingBar({ active }: LoadingBarProps) {
  if (!active) {
    return null;
  }

  return (
    <div
      aria-live="polite"
      aria-label="Refreshing data"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '2px',
        zIndex: 2000,
        background: 'linear-gradient(90deg, #1a73e8, #4fc3f7)',
      }}
    />
  );
}

export default LoadingBar;
